import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { MenuItem, Row, SplitButton } from 'seagull';
import { Send } from 'seagull/icons/emails-messages';
import { LinkIcon } from 'seagull/icons/essentials';
import { DollarCircle } from 'seagull/icons/money';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { AdHocSendOption } from '../AdHocBillModal.types';
export const GetSendSplitButtonTID = (parentTestId)=>getTestIds(parentTestId);
export const SendSplitButton = (param)=>{
    let { isFutureIssueDate, disabled, onSelect, testId } = param;
    const { SendSplitButtonTestIds } = useMemo(()=>GetSendSplitButtonTID(testId), [
        testId
    ]);
    const { t: sendButtonTexts } = useLocaleKeys('vendorOnboarding.adHocBillModal.sendButton');
    return /*#__PURE__*/ _jsxs(SplitButton, {
        label: sendButtonTexts.label(),
        testId: SendSplitButtonTestIds.Root(),
        disabled: disabled,
        onClick: ()=>onSelect(AdHocSendOption.SendByEmail),
        children: [
            /*#__PURE__*/ _jsx(MenuItem, {
                testId: SendSplitButtonTestIds.SendByEmailOption(),
                onClick: ()=>onSelect(AdHocSendOption.SendByEmail),
                children: /*#__PURE__*/ _jsxs(Row, {
                    gap: 8,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Send, {
                            size: 16
                        }),
                        sendButtonTexts.sendByEmail()
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(MenuItem, {
                testId: SendSplitButtonTestIds.ShareByLinkOption(),
                disabled: isFutureIssueDate,
                tooltipProps: isFutureIssueDate ? {
                    title: sendButtonTexts.shareByLinkDisabledTooltip(),
                    placement: 'top'
                } : undefined,
                onClick: ()=>onSelect(AdHocSendOption.ShareByLink),
                children: /*#__PURE__*/ _jsxs(Row, {
                    gap: 8,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ _jsx(LinkIcon, {
                            size: 16
                        }),
                        sendButtonTexts.shareByLink()
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(MenuItem, {
                testId: SendSplitButtonTestIds.MarkPaidExternallyOption(),
                disabled: isFutureIssueDate,
                tooltipProps: isFutureIssueDate ? {
                    title: sendButtonTexts.markPaidExternallyDisabledTooltip(),
                    placement: 'top'
                } : undefined,
                onClick: ()=>onSelect(AdHocSendOption.MarkPaidExternally),
                children: /*#__PURE__*/ _jsxs(Row, {
                    gap: 8,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ _jsx(DollarCircle, {
                            size: 16
                        }),
                        sendButtonTexts.markPaidExternally()
                    ]
                })
            })
        ]
    });
};
